// In-memory stand-in for a future access-role API (e.g. GET /me, PATCH /me/access-role).
// Call sites only deal with plain data in and plain data out, so swapping the body of
// each function for a real HTTP call later shouldn't require touching any caller.

const ACCESS_ROLES = [
  { id: 'internal', label: 'Internal team (edit + publish)', shortLabel: 'Internal team · full access' },
  { id: 'client-viewer', label: 'Client viewer (read-only)', shortLabel: 'Client viewer · read-only' }
]

let currentAccessRoleId = ACCESS_ROLES[0].id

export function listAccessRoles () {
  return ACCESS_ROLES
}

export function getCurrentAccessRole () {
  return ACCESS_ROLES.find(r => r.id === currentAccessRoleId) || ACCESS_ROLES[0]
}

export function setCurrentAccessRole (roleId) {
  if (ACCESS_ROLES.some(r => r.id === roleId)) currentAccessRoleId = roleId
}



// WEBPACK FOOTER //
// ./src/components/user-journey/journey-flow/journeyAccess.js